import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type WrapUpTimeStartedRequest = {
  Id: string;
  status: string;
  callType: string;
};

export interface WrapUpTimeCallRepository {
  getCurrentCall(): Promise<Call>;
}

export interface WrapUpTimeStartedEventPublisher {
  publish(call: WrapUpTimeStartedRequest): Promise<void>;
}
export interface WrapUpTimeStartedCallUsecase extends BaseUsecase<void> {
  run(): Promise<Call | void>;
}

export class WrapUpTimeStartedUseCase implements WrapUpTimeStartedCallUsecase {
  constructor(
    private repository: WrapUpTimeCallRepository,
    private publisher: WrapUpTimeStartedEventPublisher,
  ) {}

  async run(): Promise<void> {
    const call = await this.repository.getCurrentCall();
    if (!call) return;

    console.log('getCurrentCall - ' + call);
    const wrapUpTimeStartedRequest: WrapUpTimeStartedRequest = {
      Id: call.id,
      status: call.status,
      callType: call.type,
    };
    await this.publisher.publish(wrapUpTimeStartedRequest);
  }
}
